
import * as angular from "angular";

import { GroupService } from "@services/group.service.ajs";
import { IGroupWithIds } from "../resourceManagement/groups/_models/IGroupWithIds";
import { ExpiryOptionsModel } from "./models/ExpiryOptionsModel";
import { MessageService } from "./service/messaging.service";

export class GroupMessageController {

    messageBody = "";
    expiryOptions: ExpiryOptionsModel[] = [];
    messageReplyExpiryId: number;

    vehicleGroups: IGroupWithIds[];
    selectedGroupId: number;
    selectedGroupHasNoVehicles: boolean;

    static $inject = ["$mdDialog", "messageService", "groupService"];

    constructor(
        private $mdDialog: angular.material.IDialogService,
        private messageService: MessageService,
        private groupService: GroupService) {

        this.expiryOptions = this.messageService.getExpiryOptions();

        this.messageReplyExpiryId = this.expiryOptions[this.expiryOptions.length - 1].id;

        this.groupService
            .getGroupsWithFullMappings(true)
            .then(groups => {
                this.vehicleGroups = groups;
                this.selectedGroupId = this.vehicleGroups[0].Id;
                this.onGroupChange()
            });
    }

    onGroupChange() {
        var selectedGroup = this.vehicleGroups.find(group => group.Id == this.selectedGroupId);
        this.selectedGroupHasNoVehicles = selectedGroup.VehicleIds.length == 0;

       
    }

    sendGroupMessage() {
        const groupMessageConfig = {
            groupId: this.selectedGroupId,
            messageBody: this.messageBody,
            expiryId: this.messageReplyExpiryId
        };

        this.$mdDialog.hide(groupMessageConfig);
    }

    cancel() {
        this.$mdDialog.cancel();
    }
}
